interface CircleSVGProps {
  color: string;
  style: React.CSSProperties;
}

const CircleSVG = ({ color, style }: CircleSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
  >
    <circle cx="9.91506" cy="8.9988" r="9.00076" fill={color} />
  </svg>
);

export default CircleSVG;
